module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=DO - Dominican Republic.33b36c92.svg";